import { initPubNub, PubNubService } from "@sajilni/real-time";

const PUBNUB_PUBLISH_KEY = process.env.NEXT_PUBLIC_PUBNUB_PUBLISH_KEY as string;
const PUBNUB_SUBSCRIBE_KEY = process.env
  .NEXT_PUBLIC_PUBNUB_SUBSCRIBE_KEY as string;

let pubNubInstance: PubNubService | null = null;
let pubNubUserId: string | null = null;

/** Client-only PubNub singleton keyed by userId (re-inits if user changes). */
export function getPubNubInstance(userId: string): PubNubService | null {
  if (typeof window === "undefined") return null;
  if (!userId) return null;

  if (!pubNubInstance || pubNubUserId !== userId) {
    pubNubInstance = initPubNub(
      PUBNUB_PUBLISH_KEY,
      PUBNUB_SUBSCRIBE_KEY,
      userId
    );
    pubNubUserId = userId;
  }
  return pubNubInstance;
}
